<template>
  <div class="the-slides" v-loading="loading">
    <el-row class="the-slides__header" type="flex" align="middle">
      <el-col :span="12">
        <h3>Слайди</h3>
      </el-col>
      <el-col>
        <el-button
          class="the-slides__header-button"
          type="primary"
          size="small"
          plain
          @click="$router.push('/slides-create')">Добавити слайд</el-button>
        <el-button
          class="the-slides__header-button"
          type="success"
          size="small"
          @click="handleUpdate">Зберегти зміни</el-button>
      </el-col>
    </el-row>

    <el-card class="the-slides__card" v-for="slide in slides" :key="slide._id">
      <div slot="header" class="the-slides__card-header">

        <div class="the-slides__card-order">
          Позиція слайду:
          <el-button
            type="text"
            icon="el-icon-caret-top"
            circle
            size="mini"
            @click="handleOrderChange('up', slide._id)"></el-button>
          <span class="the-slides__card-order-value">{{ slide.order }}</span>
          <el-button
            type="text"
            icon="el-icon-caret-bottom"
            circle
            size="mini"
            @click="handleOrderChange('down', slide._id)"></el-button>
        </div>

        <el-button
          type="text"
          icon="el-icon-edit"
          circle
          size="mini"
          @click="handleEdit(slide._id)"></el-button>
        <el-switch
          v-model="slide.isActive"
          class="the-slides__card-toggle-button"
          title="Вкл/викл слайд"
          @change="handleToggle(slide._id)"></el-switch>
      </div>

      <div class="the-slides__card-title" v-html="slide.title"></div>

      <img class="the-slides__card-img" :src="slide.previewPicture" alt="">
    </el-card>
  </div>
</template>

<script>
/**
 * Component: the-slides - Компонент списка слайдов
 *
 * @version 1.0.0
 */

const ORDER = {
  MIN: 1,
  MAX: 10,
}

import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'the-slides',

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
      slides: 'slides/slides',
    }),
  },

  async created() {
    await this.getSlides();
    this.loading = false;
  },

  methods: {
    ...mapMutations({
      changeSlide: 'slides/changeSlide',
    }),
    ...mapActions({
      getSlides: 'slides/getSlides',
      updateSlides: 'slides/updateSlides',
    }),

    handleOrderChange(type, _id) {
      const slide = this.slides.find(e => e._id === _id);

      if (type === 'up') {
        if (slide.order === ORDER.MAX) {
          return;
        }

        this.changeSlide({
          ...slide,
          order: slide.order + 1,
          changed: true,
        });
      }
      if (type === 'down') {
        if (slide.order === ORDER.MIN) {
          return;
        }

        this.changeSlide({
          ...slide,
          order: slide.order - 1,
          changed: true,
        });
      }
    },

    handleEdit(_id) {
      this.$router.push(`/slides-create?id=${_id}`);
    },

    handleToggle(_id) {
      // eslint-disable-next-line
      let slide = this.slides.find(e => e._id === _id);

      this.changeSlide({
        ...slide,
        changed: true,
      });
    },

    async handleUpdate() {
      // eslint-disable-next-line
      const slidesToUpdate = this.slides.filter(e => e.changed).map(({_id, order, isActive}) => ({
        _id,
        order,
        isActive,
      }));

      this.loading = true;

      if (slidesToUpdate.length) {
        try {
          await this.updateSlides(slidesToUpdate);
        } catch (e) {
          console.log(e);
        }
      } else {
        this.$message('Немає змін для збереження');
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-slides {
  $this: &;

  &__header {
    margin-bottom: $vp;

    &-button {
      float: right;

      + #{&} {
        margin-right: $vp;
      }
    }
  }

  &__card {
    max-width: 500px;
    margin-bottom: $vp;

    &-header {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 22px;
      }
    }
    &-order {
      margin-right: auto;

      &-value {
        display: inline-block;
        padding: 0 5px;
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        font-weight: 700;
        border: 1px solid #B3C0D1;
        border-radius: 3px;
        text-align: center;
      }
    }
    &-toggle-button {
      margin-left: 15px;
    }
    &-title {
      margin-bottom: $vp;
    }
    &-img {
      max-width: 100%;
    }
  }
}
</style>
